export class AClaveRequest {
    Country: string;
    SamlRequestField: string;
    RelayStateField: string;
    RelayState: string;
    Url: string;
    Metodo: string;
    Request: string;
}

export const COOKIE_CLAVE_NAME = 'Cexvegweb_SessionId'; // Deberá ser el mismo que el configurado en las appsettings del core.

export const XsrfTokenKey = 'X-XSRF-TOKEN';
export const TokenStartsWith = 'CSRF-TOKEN=';

export enum ERROR_CLAVE_KEYS {
    LOGINKO = 'loginko',
    NOT_AUTHORIZED = 'notauthorized',
    LOGOUT = 'logout',
    UNSUCESSFULL_LOGIN = 'unsuccessfulllogin',
    UNSUCESSFULL_LOGOUT = 'unsuccessfulllogout',
}
